import {useLocation} from 'react-router-dom'

/**
 * Custom hook to determine if a query should be skipped based on the current route
 *
 * @param {string|string[]} routePatterns - String or array of strings that should be present in the route for the query to execute
 * @returns {boolean} - True if the query should be skipped (when route doesn't match), false if it should execute
 *
 * @example
 * // Skip if not in admin panel
 * const shouldSkip = useRouteBasedSkip('/adminpanel');
 *
 * @example
 * // Skip if not in timeseries
 * const shouldSkip = useRouteBasedSkip(['/timeseries']);
 */
export default function useRouteBasedSkip(routePatterns) {
  const location = useLocation()
  const currentRoute = location.pathname
  const patterns = Array.isArray(routePatterns) ? routePatterns : [routePatterns]
  // Prevent '/' from matching everything
  const routeMatches = patterns.some(
    (pattern) => currentRoute === pattern || (pattern !== '/' && currentRoute.startsWith(pattern))
  )
  return !routeMatches
}
